import Axios from "axios"
import { toast } from "react-toastify"
/**
 * در اینجا نوع های مختلف ارسال داده و ودریافت داده استفاده شده است
 */
export const postCreate = async (url, authen, dataFrom, handelLoadingform, handelAdd, handeldmicro, handelerrors) => {

    try {
        const res = await Axios.post(url, JSON.stringify(dataFrom), {
            headers: {
                "Authorization": authen,
                "Content-Type": "application/json; charset=utf-8 "
            }
        })
        const data = await res.data
        handelLoadingform(false)
        toast.success(data.message, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
        });
        handelAdd(false);
        handeldmicro(false);
    } catch (error) {
        handelerrors(error);
        handelLoadingform(false)
    }

}


export const getUpdate = async (url, authenticationurl, handelloding, handelAdd, handelEdit, handelDataUpdate, handeldmicro, handelerrors) => {
    try {
        const res = await Axios.get(url, {
            headers: {
                "Authorization": authenticationurl,
                "Content-Type": "application/json; charset=utf-8 "
            }
        })
        const data = await res.data.data
        handelDataUpdate(data)
        handelloding(false)
    } catch (error) {
        handelerrors(error)
        handelEdit('')
        handelAdd(false)
        handeldmicro(false)


    }
}


export const PutUpdate = async (url, dataFrom, authenticationurl, handelLoadingform, handelEdit, handelAdd, handeldmicro, handelerrors, userprofile, handelEditOrder) => {
    try {
        const res = await Axios.put(url, JSON.stringify(dataFrom), {
            headers: {
                "Authorization": authenticationurl,
                "Content-Type": "application/json; charset=utf-8 "
            }
        })
        const data = await res.data
        handelLoadingform(false)
        toast.success(data.message, {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        handelEdit('')
        handelAdd(false)
        handeldmicro(false)
        if (userprofile) {
            handelEditOrder(false)
        }
    } catch (error) {
        handelerrors(error)
        handelLoadingform(false)


    }

}


export const getdata = async (url, authenticationurl, handelData, handelloding, handelAdd, handeldmicro, handelerrors) => {

    try {
        const res = await Axios.get(url, {
            headers: {
                "Authorization": authenticationurl,
                "Content-Type": "application/json; charset=utf-8 "
            }
        })
        const data = await res.data.data
        handelData(data)
        handelloding(false)
    } catch (error) {
        handelerrors(error)
        handelAdd(false)
        handeldmicro(false)


    }

}